import { SxProps, Theme } from '@mui/material';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import React from 'react';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import useDispatchNumberLabel from '~hooks/useDispatchNumberLabel';
import { Project } from '~hooks/useProjects/models';

import { Label, Value } from '../../styled';

interface SubtitleProps {
  project: Project;
  sx?: SxProps<Theme>;
}

export default function Subtitle({ project, sx }: SubtitleProps) {
  const { singular } = useDispatchNumberLabel();
  const nodes: React.ReactNode[] = [];

  if (project.dispatchNumber?.name) {
    nodes.push(
      <>
        <Label>{singular('ticket_drawer_v2.digital_ticket.dispatch_number')}: </Label>
        <Value>{project.dispatchNumber.name}</Value>
      </>,
    );
  }

  if (project.externalId) {
    nodes.push(
      <>
        <Label>{t('dispatch.dispatch_v3.project_external_id')}: </Label>
        <Value>{project.externalId}</Value>
      </>,
    );
  }

  return (
    <OverflowAwareText sx={[{ fontSize: '12px' }, ...(Array.isArray(sx) ? sx : [sx])]}>
      {nodes.map((node, index) => (
        <React.Fragment key={index}>
          {node}

          {nodes.length - 1 !== index && (
            <Typography
              component="span"
              sx={(theme) => ({
                color: theme.palette.primary.contrastText,
                fontSize: 'inherit',
                mx: 0.5,
              })}
            >
              {'•'}
            </Typography>
          )}
        </React.Fragment>
      ))}
    </OverflowAwareText>
  );
}
